import template from "./location_holds.html";
import controller from "./location_holds.controller";
import "./location_holds.scss";

let branchManagementLocationHoldsComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementLocationHoldsComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/location_holds/location_holds.component.js